// WarningText.js
import React from 'react';
import { toAbsoluteUrl } from '../../Utils/_helpers';
import { isFeatureEnabledProfile } from './helpers';

const WarningText = ({ className , message }) => {

  const isSuspendedAccount = isFeatureEnabledProfile('is_suspended_account');
  const suspensionType = isFeatureEnabledProfile('suspension_type');
  const generateSystemInvoice = isFeatureEnabledProfile('generate_system_invoice');

  return (
    <>
      {isSuspendedAccount ?
        <div className='highlighted-suspended-account-text'>
          {suspensionType === 'coin' ? (
            generateSystemInvoice === 1 ? (
              <span>Your account has been suspended, please contact your engagement manager(or support) for further assistance.</span>
            ) : (
              <span>Your account has been suspended due to low coin balance. Please add coins immediately to resume your services.</span>
            )
          ) : (
            <span>Your account has been suspended for non-submission of KYC. Please submit immediately for approval to resume your services.</span>
          )}
        </div>
        :
        <div className="highlighted-warning-text">
        <span className={className}>
          <img
            alt=""
            src={toAbsoluteUrl('/media/sr/icons/warning-octagon.png')}
            style={{ marginRight: '10px' }}
            height={24}
          />
          <span style={{ width: "max-content" }}>{message}</span>
        </span>
        </div>
      }
    </>
  );
};

export default WarningText;
